import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { CardGreyHeadline, SettingsScheduleDefaultStock, SettingsScheduleHolidays } from 'components/Card'
import { ScheduleType } from 'types/schedule'
import { Spacer } from 'components/Utility'

type Props = {
  headline: string
  prevSchedules: ScheduleType[]
  schedules: ScheduleType[]
  title: string
}

const SettingsScheduleCard: FC<Props> = (props) => {
  const { headline, prevSchedules, schedules, title } = props
  // 追加されたschedulesを取得する
  const addedSchedules = schedules.filter((schedule) =>
    prevSchedules.every((prevSchedule) => prevSchedule.schedule_ref?.id !== schedule.schedule_ref?.id)
  )
  return (
    <div className={styles.settings}>
      <div className={styles.settings__header}>
        <h4 className={styles.settings__header__title}>{title}</h4>
      </div>
      <CardGreyHeadline headline={headline} />
      {prevSchedules.map((prevSchedule) => {
        // 変更後のスケジュールを取得
        const schedule = schedules.find((_schedule) => {
          return _schedule.schedule_ref?.id === prevSchedule.schedule_ref?.id
        })
        // 定休日に変更があったか
        const isSameHolidays = schedule
          ? prevSchedule.days_of_week.every((dayOfWeek) => schedule.days_of_week.includes(dayOfWeek))
          : true
        return (
          <div className={styles.settings__body} key={prevSchedule.schedule_ref?.id}>
            <SettingsScheduleHolidays schedule={schedule ?? prevSchedule} isSameHolidays={isSameHolidays} />
            <Spacer size={8} />
            {schedule
              ? schedule.default_stocks.map((defaultStock) => {
                  // オープン時刻の変更により、受渡解禁時刻が変更されたかどうか
                  const isUpdatedPickupableTime = prevSchedule.default_stocks.every((prevDefaultStock) => {
                    return prevDefaultStock.pickupable_time !== defaultStock.pickupable_time
                  })

                  const isUpdatedStock = prevSchedule.default_stocks.every((prevDefaultStock) => {
                    return prevDefaultStock.stock !== defaultStock.stock
                  })

                  return (
                    <SettingsScheduleDefaultStock
                      key={defaultStock.pickupable_time}
                      defaultStock={defaultStock}
                      isUpdatedPickupableTime={isUpdatedPickupableTime}
                      isUpdatedStock={isUpdatedStock}
                    />
                  )
                })
              : prevSchedule.default_stocks.map((prevDefaultStock) => {
                  const isUpdatedPickupableTime = false
                  const isUpdatedStock = false

                  return (
                    <SettingsScheduleDefaultStock
                      key={prevDefaultStock.pickupable_time}
                      defaultStock={prevDefaultStock}
                      isUpdatedPickupableTime={isUpdatedPickupableTime}
                      isUpdatedStock={isUpdatedStock}
                    />
                  )
                })}
          </div>
        )
      })}
      {addedSchedules.map((addedSchedule) => (
        <div className={styles.settings__body} key={addedSchedule.schedule_ref?.id}>
          <SettingsScheduleHolidays schedule={addedSchedule} isSameHolidays={false} />
          <Spacer size={8} />
          {addedSchedule.default_stocks.map((addedDefaultStock) => (
            <SettingsScheduleDefaultStock
              key={addedDefaultStock.pickupable_time}
              defaultStock={addedDefaultStock}
              isUpdatedPickupableTime={true}
              isUpdatedStock={false}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default SettingsScheduleCard
